import { render, staticRenderFns } from "./SidebarTab.vue?vue&type=template&id=2dcc8648&scoped=true&"
import script from "./SidebarTab.vue?vue&type=script&lang=js&"
export * from "./SidebarTab.vue?vue&type=script&lang=js&"
import style0 from "./SidebarTab.vue?vue&type=style&index=0&id=2dcc8648&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcc8648",
  null
  
)

export default component.exports